import '../scss/main.scss';
import LogoGrid from './sections/logo_grid';
import CampaignExamples from './sections/campaign_examples';
import QuoteSlider from './sections/quote-slider';
import ThreeCards from './sections/3_cards';
import Hero from './sections/hero';

// Initialize sections when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new LogoGrid().init();
  new CampaignExamples().init();
});
